"use client";

import { useSeriesFavorite, useToast } from "app/hooks";
import { usePathname } from "next/navigation";
import { MouseEventHandler, useSyncExternalStore } from "react";
import { MdStar, MdStarBorder } from "react-icons/md";
import { generateAuthLinkUrl } from "./AuthLink";
import { sessionStore } from "@lib/sessionStore";
import Link from "next/link";
import { controlMissionToast } from "@lib/utils";

const labelText = {
  addFav: "作品をお気に入りに追加",
  alreadyFav: "お気に入りに追加済",
  registerAndFav: "登録してお気に入り",
};

function ButtonBody({ faved, isLoggedIn }: { faved: boolean | undefined; isLoggedIn: boolean }) {
  return (
    <>
      {faved ? (
        <MdStar className="ep-detail-fav-icon" />
      ) : (
        <MdStarBorder className="ep-detail-fav-icon" />
      )}
      <span className="ep-detail-fav-label">
        {isLoggedIn ? (faved ? labelText.alreadyFav : labelText.addFav) : labelText.registerAndFav}
      </span>
    </>
  );
}

export function EpisodeDetailFavBtn({ seriesHash }: { seriesHash: string }) {
  const { session, sessionStatus } = useSyncExternalStore(
    sessionStore.subscribe,
    sessionStore.getSnapshot,
    sessionStore.getServerSnapshot,
  );
  const { results, isLoading, toggle } = useSeriesFavorite(
    seriesHash,
    sessionStatus === "authenticated",
  );
  const { pushToast } = useToast();
  const faved = results?.favoriteStatus?.favorite;
  const pathname = usePathname();
  const handleFav: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (!session?.user) {
      return;
    }
    e.preventDefault();
    toggle().then((res) => {
      if (Array.isArray(res)) controlMissionToast(res, pushToast);
    });
  };
  return (
    <Link
      href={
        sessionStatus === "unauthenticated"
          ? generateAuthLinkUrl(pathname, undefined, "signup")
          : ""
      }
      onClick={handleFav}
      className={
        "ep-detail-fav" +
        (isLoading ? " mode-loading" : faved ? " mode-faved" : "") +
        (session?.user ? "" : " mode-not-user")
      }
    >
      <ButtonBody faved={faved} isLoggedIn={Boolean(session?.user)} />
    </Link>
  );
}
